import { ReportProfileDeviceSyncModel, ReportProfileDeviceModel } from '@i2a/web-api-client';

export class DeviceWithAlert {
    name: string;
    image: string;
    hasAlert: boolean;
    hasAlertRecentlyClosed: boolean;
    lastActionDate: Date;
    model: ReportProfileDeviceModel | ReportProfileDeviceSyncModel;
}